<template>
    <div>

        <!--Alertes création token-->
        <v-snackbar color="success" top v-model="create.successInClipboard">Le token a été copié dans votre
            presse-papier
            <v-icon dark>mdi-check-circle</v-icon>
        </v-snackbar>
        <v-alert border="left" dismissible elevation="2" transition="slide-y-transition"
                 type="success" v-model="create.successShowToken">
            Le token créé est<br/>
            <pre>{{create.token}}</pre>
        </v-alert>

        <!--Alertes édition token-->
        <v-snackbar color="success" top v-model="edit.success">Le token a été modifié
            <v-icon dark>mdi-check-circle</v-icon>
        </v-snackbar>
        <v-snackbar color="error" top v-model="edit.error">Une erreur est survenue</v-snackbar>

        <!--Bouton création token-->
        <v-btn @click="create.show=true" class="mb-4" block color="primary">Créer un token</v-btn>
        <!-- Tableau -->
        <token-table @token-selected="tokenHasBeenSelected" ref="tokenTable"/>

        <!--Dialogue de création de token-->
        <v-dialog max-width="400" v-model="create.show">
            <v-card :loading="create.submitting">
                <v-card-title>Créer un token</v-card-title>
                <v-card-text>
                    <token-form @created="newTokenHasBeenCreated" v-model="create.submitting"/>
                    <!-- TODO Modifier pour que le formulaire soit géré par le parent -->
                </v-card-text>
            </v-card>
        </v-dialog>

        <!--Dialogue de modification de token-->
        <v-dialog max-width="400" v-model="edit.show">
            <v-card :loading="edit.submitting">
                <v-card-title>Modifier un token</v-card-title>
                <v-card-text>
                    <v-form @submit.prevent="tokenEditFormHasBeenSubmitted">
                        <v-text-field :disabled="true" label="Service" v-model="edit.token.serviceName"/>
                        <v-text-field label="Commentaire" v-model="edit.token.label"/>
                        <v-checkbox label="Actif" v-model="edit.token.active"/>
                        <v-btn :loading="edit.submitting" color="primary" type="submit">Envoyer</v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
	import TokenTable from "../../components/TokenTable";
	import TokenForm from "../../components/TokenForm";
	import copy from 'copy-to-clipboard'

	export default {
		name: "TokenListView",
		components: {TokenForm, TokenTable},
		data() {
			return {
				create: {
					show: false,
					submitting: false,
					successInClipboard: false,
					successShowToken: false,
					token: ""
				},
				edit: {
					show: false,
					token: {
						serviceName: "",
						label: "",
						active: false
					}
				}
			}
		},
		methods: {
			newTokenHasBeenCreated(tokenData) {
				this.$refs.tokenTable.refresh();
				this.create.show = false;
				if (copy(tokenData.tokenString)) {
					this.create.successShowToken = true;
					this.create.token = tokenData.tokenString;
				} else this.create.successInClipboard = true;
			},
			tokenEditFormHasBeenSubmitted() {
				this.edit.submitting = true;
				this.$http.put(this.$config.apiUrl + "/v2/services/" + this.edit.token.serviceName + "/tokens/" + this.edit.token.id, this.edit.token)
					.then(() => {
						this.edit.success = true;
						this.edit.show = false;
						this.$refs.tokenTable.refresh();
					})
					.catch(() => this.edit.error = true)
					.finally(() => this.edit.submitting = false)
			},
			tokenHasBeenSelected(token) {
				this.edit.token = token;
				this.edit.show = true;
			}
		}
	}
</script>

<style scoped>

</style>
